module.exports = __webpack_public_path__ + "./docs/img/diagnostic.f2c9c76fc0c1524241684831824e969b.svg";